import React, { Component } from 'react'

export default class workplaceService extends Component {
    render() {
        return (
           
<svg className={this.props.className} onClick={this.props.onClick}  width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.1328 7.66406H4.13281C3.02824 7.66406 2.13281 8.55949 2.13281 9.66406V19.6641C2.13281 20.7686 3.02824 21.6641 4.13281 21.6641H20.1328C21.2374 21.6641 22.1328 20.7686 22.1328 19.6641V9.66406C22.1328 8.55949 21.2374 7.66406 20.1328 7.66406Z" stroke="#001F82" strokeWidth="1.6" stroke-linecap="round" strokeLinejoin="round"/>
<path d="M16.1328 21.6641V5.66406C16.1328 5.13363 15.9221 4.62492 15.547 4.24985C15.172 3.87478 14.6632 3.66406 14.1328 3.66406H10.1328C9.60238 3.66406 9.09367 3.87478 8.7186 4.24985C8.34353 4.62492 8.13281 5.13363 8.13281 5.66406V21.6641" stroke="#001F82" strokeWidth="1.6" stroke-linecap="round" strokeLinejoin="round"/>
</svg>

        )
    }
}
